import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as gql from './gql'
import type { TypeParams } from './types'

/** Space record API, for fetching and updating space records */
@ngCore.Injectable()
export class Api implements ec.models.Api<TypeParams> {
  /** @inheritdoc */
  public list = ec.models.Api.list.using.onlyFilter<TypeParams>(
    (context, { filter }) => {
      if (!context) {
        return rxjs.of([])
      }

      const { additionalFilters, searchTerm: search } = filter ?? {}
      return gql.queries.employees.executor({
        ...context,
        filter: {
          ...gql.transformers.EMPLOYEE_FILTERS.getGqlFrom(additionalFilters),
          search,
        },
      })
    },
  )

  /** @inheritdoc */
  public create: ec.models.Api<TypeParams>['create'] = (context, input) => {
    if (!context) {
      return rxjs.of(undefined)
    }
    return gql.mutations.createEmployee.executor({
      ...context,
      input,
    })
  }
}
